import PropTypes from 'prop-types'
import { Upload } from '../../reutilizables/upload/Upload'
import Input from '../../ui/Input'
import LinkButton from '../../ui/LinkButton'
import styles from './responder.module.css'

export const Responder = ({
  idUsuarioChat,
  idMensaje,
  usuario,
  handleChange,
  texto,
  errores,
  mensaje,
  submitRespuesta,
  valido,
  idPublicacion,
  adjuntoPendiente,
  setAdjuntoPendiente,
  manejarAdjunto
}) => {
  const adjuntos = adjuntoPendiente?.[idMensaje] || []

  const eliminarAdjunto = (indice) => {
    const nuevosAdjuntos = adjuntos.filter((_, i) => i !== indice)

    setAdjuntoPendiente((prev) => ({
      ...prev,
      [idMensaje]: nuevosAdjuntos.length > 0 ? nuevosAdjuntos : undefined
    }))
  }

  const getFileIcon = (filename) => {
    if (filename.endsWith('.pdf')) {
      return 'fa-file-pdf-o'
    }
    if (filename.endsWith('.doc') || filename.endsWith('.docx')) {
      return 'fa-file-word-o'
    }
    if (filename.endsWith('.xls') || filename.endsWith('.xlsx')) {
      return 'fa-file-excel-o'
    }
    return 'fa-file-o'
  }

  return (
    usuario &&
    usuario === idUsuarioChat && (
      <div className="row mt-2">
        <div className="col-9">
          <Input
            type="text"
            name={`mensaje-${idMensaje}`}
            value={texto[`mensaje-${idMensaje}`] || ''}
            onChange={(e) => handleChange(e, `mensaje-${idMensaje}`)}
            className="buscar"
            placeholder="Escribe tu respuesta"
            errores={errores}
          />
          {adjuntos.length > 0 && (
            <div className={styles.adjuntosContainer}>
              <div className={styles.adjuntosList}>
                {adjuntos.map((adjunto, indice) => (
                  <div key={indice} className={styles.previewAdjunto}>
                    {adjunto.contentType?.startsWith('image/') ? (
                      <img src={adjunto.url} alt="preview" className={styles.previewImagen} />
                    ) : (
                      <a
                        href={adjunto.url}
                        target="_blank"
                        rel="noreferrer"
                        className={styles.archivoNombre}
                        title={adjunto.nombre}
                      >
                        <i className={`fa ${getFileIcon(adjunto.nombre)}`} />
                        <span className={styles.archivoTexto}>{adjunto.nombre}</span>
                      </a>
                    )}
                    <button
                      type="button"
                      className={styles.removeAdjunto}
                      onClick={() => eliminarAdjunto(indice)}
                      aria-label="Quitar adjunto"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          <Upload
            idDoc={idPublicacion}
            idPerfil={usuario}
            idTipo={'10'}
            adjuntoPendiente={adjuntoPendiente?.[idMensaje] || []}
            onCarga={(data) => manejarAdjunto(data.data, setAdjuntoPendiente, idMensaje)}
          />
        </div>

        <div className="col">
          <LinkButton
            className="btn btn-preguntar"
            onClick={(e) => {
              e.preventDefault()
              const value = texto[`mensaje-${idMensaje}`] || ''
              if (valido(value)) {
                submitRespuesta(idMensaje, value, mensaje)
              }
            }}
          >
            Responder
          </LinkButton>
        </div>
      </div>
    )
  )
}

Responder.propTypes = {
  idUsuarioChat: PropTypes.number,
  idMensaje: PropTypes.number.isRequired,
  usuario: PropTypes.number,
  handleChange: PropTypes.func.isRequired,
  texto: PropTypes.objectOf(PropTypes.string).isRequired,
  errores: PropTypes.object.isRequired,
  mensaje: PropTypes.object.isRequired,
  submitRespuesta: PropTypes.func.isRequired,
  valido: PropTypes.func.isRequired,
  idPublicacion: PropTypes.number.isRequired,
  adjuntoPendiente: PropTypes.objectOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        nombre: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        contentType: PropTypes.string
      })
    )
  ),
  setAdjuntoPendiente: PropTypes.func.isRequired,
  manejarAdjunto: PropTypes.func.isRequired
}
